import ForestCard from '@/components/me/footprint/ForestCard'
import DamoCard from '@/components/me/footprint/DamoCard'
import IntCard from '@/components/me/footprint/IntCard'
import ZooCard from '@/components/me/footprint/ZooCard'
import FshopCard from '@/components/me/footprint/FshopCard'

export default {
  grade: {
    primary: '大众会员',
    golden: '黄金会员',
    platinum: '铂金会员',
    diamond: '钻石会员',
  },
  date: {
    week: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
    am: '上午',
    pm: '下午',
  },
  famPicker: {
    instruction: '添加家庭成员',
    addAdult: '添加成人',
    addChild: '添加小孩',
  },
  addAdult: {
    title: '邀请TA扫码一起参观',
    instruction: '用支付宝扫二维码,一起参观',
    warning: ['该支付宝二维码将于', '失效'],
    download: ['点击下载二维码', '发送给朋友'],
    pending: ['扫码成功, 等待对方确认', '请对方在手机上确认'],
    success: ['添加成功'],
  },
  btn: {
    nextStep: '下一步',
    resNow: '立即预约',
    complete: '完成',
    genReport: '生成体验报告',
  },
  me: {
    fam: {
      title: '家庭成员',
      // subtitle: '可添加1个成人, 2个儿童一起体验展项',
      subtitle: '可添加1个儿童一起体验展项',
    },
    res: {
      title: '我的预约',
    },
    footprint: {
      title: '我的足迹',
      subtitle: '查看游戏成绩, 或数码纪念品',
    },
  },
  footprints: {
    '2': {
      name: '阿里动物园',
      layout: ZooCard,
      icon: require('src/assets/icons/exps/zoo.png'),
      card: require('src/assets/icons/exps/zoo.jpg'),
    },
    '3': {
      name: '飞跃蚂蚁森林',
      layout: ForestCard,
      icon: require('src/assets/icons/exps/forest.png'),
      card: require('src/assets/icons/exps/forest.jpg'),
    },
    '4': {
      name: 'DAMO 5G赛车',
      layout: DamoCard,
      icon: require('src/assets/icons/exps/5g.png'),
      card: require('src/assets/icons/exps/5g.jpg'),
    },
    '5': {
      name: '互动区',
      layout: IntCard,
      icon: require('src/assets/icons/exps/int.png'),
      card: require('src/assets/icons/exps/int.jpg'),
    },
    '6': {
      name: '未来商店',
      layout: FshopCard,
      icon: require('src/assets/icons/exps/fshop.png'),
      card: require('src/assets/icons/exps/fshop.jpg'),
    },
  },
}
